import React, { useState, useEffect } from "react";

function Property_document({school_port}) {
    const [selectedImage, setSelectedImage] = useState();

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          const imageUrl = URL.createObjectURL(file);
          setSelectedImage(imageUrl);
          school_port(true)
        }
      };
  return (
    <div className='property_doc_Inner'>
        <div className='docs'>

            <div className='img_Disp'><img src={selectedImage} /></div>

            <div className='label_DIV'><label className='img_label' htmlFor="file-upload">Click to Choose Property Document (jpeg format)</label></div>
            <input className='choose_img' accept="image/jpeg, image/jpg"  id="file-upload"  type='file' onChange={handleImageChange} />

        </div>
    </div>
  )
}

export default Property_document